import site from './site'
import { SiteState } from './types'

const siteReducer = (state: SiteState = site) => state

export default siteReducer



// WEBPACK FOOTER //
// ./src/state/site/reducer.ts